import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { LoadingService, MessageEventService } from "@obg/ngx.global";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { ReplaySubject, Subscription } from "rxjs";

@Directive({
	selector: "iframe[obgIframe]",
})
export class IFrameDirective implements AfterViewInit, OnDestroy {
	@Input()
	@coerceBoolean()
	trustRedirects = false;

	/**
	 * When it is set to `false` and the iframe has loaded, messages will be sent to the iframe.
	 * Consumer can set it to `true` initially to delay when the messages will be posted to the iframe after loading.
	 */
	@Input()
	@coerceBoolean()
	delayMessages = false;

	@Input()
	@coerceBoolean()
	useOverlayLoader = false;

	@Output() load = new EventEmitter<void>();

	private messageScheduler$: ReplaySubject<any> = new ReplaySubject();
	private messageSchedule$$: Subscription | undefined;
	private isLoading = false;

	constructor(
		private element: ElementRef<HTMLIFrameElement>,
		private loadingService: LoadingService,
		private messageEventService: MessageEventService
	) {}

	postMessage(message: any) {
		this.messageScheduler$.next(message);
	}

	ngAfterViewInit() {
		if (this.useOverlayLoader) {
			this.loadingService.open();
			this.isLoading = true;
		}
		this.element.nativeElement.addEventListener("load", this.onLoadSuccess);
	}

	ngOnDestroy() {
		if (this.useOverlayLoader && this.isLoading) {
			this.loadingService.close();
			this.isLoading = false;
		}
		this.messageSchedule$$?.unsubscribe();
		this.element.nativeElement.removeEventListener("load", this.onLoadSuccess);
	}

	onLoadSuccess = () => {
		if (this.useOverlayLoader && this.isLoading) {
			this.loadingService.close();
			this.isLoading = false;
		}
		this.load.emit();
		this.subscribeToScheduler();
	};

	private subscribeToScheduler() {
		if (!this.delayMessages && !this.messageSchedule$$) {
			this.messageSchedule$$ = this.messageScheduler$.subscribe((message) => this.handlePostMessage(message));
		}
	}

	private handlePostMessage(message: any) {
		const iFrame = this.element?.nativeElement as HTMLIFrameElement;
		if (!iFrame?.contentWindow) {
			return;
		}

		this.messageEventService.postMessage(
			message,
			iFrame.contentWindow,
			this.trustRedirects ? "*" : this.element.nativeElement.src
		);
	}
}
